export default "__VITE_ASSET__BUoys2o3__"